import { initWebworker, unregisterCallbackByMethod } from "../src/index.ts";

export type WorkerType =  {
    greet : (name: string) => Promise<string>;
    greet2 : () => Promise<string>;
    greet3 : (name1 : string , name2: string) => Promise<string>;
    withCallback: (callback: (test: string) => void) => Promise<() => void>;
}

initWebworker<WorkerType>({
    greet: async (name : string) => `Hello ${name}`,
    greet2 : async () => "Hello",
    greet3 : async (name1, name2) => `Hello ${name1}, ${name2}`,
    withCallback : async (callback: (test: string) => void) => { 
        const handle = setInterval(() => callback("ping"), 1000);
        return () => {
            unregisterCallbackByMethod(callback)
            clearInterval(handle); 
        }
    }
});